export default "__VITE_ASSET__a728339e__"